import { Grid } from '@mui/material';
import TwAutocomplete, {
  TwAutocompleteOption
} from '../../../components/TwAutocomplete/TwAutocomplete';
import { locationTypeOptions } from '../../../utils/location/location';
import { FormikErrors, FormikValues } from 'formik';
import { CustomerLocationField } from './CustomerLocationField';
import { PortOfEntryField } from './PortOfEntryField';
import React, { FC, useEffect, useMemo } from 'react';
import { CreateLocationFormValues } from '../CreateLocation/CreateLocation';
import useFeatureFlags from '../../../providers/FeatureFlags/FeatureFlags.provider';
import { LOCATION_TYPE } from '../../../redux/api/load/load.model';

interface LocationTypeFieldsProps {
  values: CreateLocationFormValues;
  setFieldValue: FormikValues['setFieldValue'];
  customerDisabled?: boolean;
}

export const LocationTypeFields: FC<LocationTypeFieldsProps> = ({
  values,
  setFieldValue,
  customerDisabled
}) => {
  const { enableBorderConnect } = useFeatureFlags();
  const options = useMemo(() => locationTypeOptions(enableBorderConnect), [enableBorderConnect]);

  useEffect(() => {
    if (!customerDisabled) return;
    const option = options.find((v) => v.value === LOCATION_TYPE.CUSTOMER);
    setFieldValue('type', option);
  }, [customerDisabled]);

  return (
    <Grid container justifyContent="space-between">
      <Grid
        item
        md={5.8}
        xs={12}
        className={
          customerDisabled
            ? 'edit-location__wrapper edit-location__disabled-fields '
            : 'edit-location__wrapper'
        }
      >
        <TwAutocomplete
          id="type"
          name="type"
          label="Address type"
          value={values.type}
          optionList={options}
          sortList={false}
          disabled={customerDisabled}
          onChange={(
            _,
            newValue: TwAutocompleteOption | null
          ): Promise<void> | Promise<FormikErrors<CreateLocationFormValues>> => {
            setFieldValue('port_code', null);
            return setFieldValue('type', newValue);
          }}
        />
      </Grid>
      <Grid
        item
        md={5.8}
        xs={12}
        className={
          customerDisabled
            ? 'edit-location__wrapper edit-location__disabled-fields '
            : 'edit-location__wrapper'
        }
      >
        <CustomerLocationField
          values={values}
          setFieldValue={setFieldValue}
          disabled={customerDisabled}
        />
        <PortOfEntryField values={values} setFieldValue={setFieldValue} />
      </Grid>
    </Grid>
  );
};
